export * from './api/contentful'
export * from './api/mappers'
export * from './api/interfaces'

import Header from './Header'

export {default as AccordionMenu} from './components/AccordionMenu'

export {default as getExampleData} from './data/exampleData'

export {default as theme} from './theme'

export type {Theme} from './theme'

export {default as SimplifiedHeader} from './SimplifiedHeader'

export default Header
